import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { path, clone } from 'ramda';
import Input from '../Input';
import TextArea from '../TextArea';
import {currencyToDollars} from "../../utils/currency";

export default class FinInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fields: {},
    };
    this.changeField = this.changeField.bind(this);
    this.buildFields = this.buildFields.bind(this);
    this.getMaterialsCost = this.getMaterialsCost.bind(this);
  }

  buildFields() {
    const fields = this.props.fields;
    const field = {
      label: '',
      placeholder: '',
      system: {
        name: '',
      },
      value: '',
      errors: [],
      type: 'text',
      name: '',
      rules: {
        required: false,
      }
    };
    const objFields = {};
    const components = [];

    if (fields) {
      for (let key in fields) {
        switch (key) {
          case 'material':
            objFields['material'] = clone(field);
            objFields['material'].label = 'Consumables and Supplies';
            objFields['material'].placeholder = '';
            break;
          case 'labor':
            objFields['labor'] = clone(field);
            objFields['labor'].label = 'Labor';
            objFields['labor'].placeholder = '';
            break;
          case 'price':
            objFields['price'] = clone(field);
            objFields['price'].label = 'Price';
            objFields['price'].placeholder = '';
            break;
          case 'price-paint':
            objFields['price-paint'] = clone(field);
            objFields['price-paint'].label = 'Price paint';
            objFields['price-paint'].placeholder = '';
            break;
          case 'price-body':
            objFields['price-body'] = clone(field);
            objFields['price-body'].label = 'Price body';
            objFields['price-body'].placeholder = '';
            break;
          case 'taxes':
            objFields['taxes'] = clone(field);
            objFields['taxes'].label = 'Taxes';
            objFields['taxes'].placeholder = '';
            break;
          case 'body-work':
            objFields['body-work'] = clone(field);
            objFields['body-work'].label = 'Notes';
            objFields['body-work'].placeholder = '';
            break;
        }

        objFields[key].value = fields[key];
        objFields[key].system.name = key;
        objFields[key].name = key;
      }
    }

    for (let key in objFields) {
      if (key === 'material') {
        components.push(
          <div className="row" style={{ alignItems: 'end' }}>
            <div className="col col-lg-10">
              <Input
                disabled={this.props.disabled}
                field={objFields[key]}
                onChange={this.changeField}
              />
            </div>
            <div className="col col-lg-2" style={{ textAlign: 'end' }}>
              <button
                type="button"
                className={'btn btn-success btn-outline'}
                onClick={this.getMaterialsCost}
                style={{ marginBottom: '16px', height: '38px' }}
              >
                <i className="fa fa-refresh"></i>
                <span style={{ paddingLeft: '3px' }}>Calculate</span>
              </button>
            </div>
          </div>
        );
      } else if (key === 'labor') {
        components.push(
            <div className="row" style={{alignItems: 'end'}}>
              <div className="col col-lg-8">
                <Input
                  disabled={this.props.disabled}
                  field={objFields[key]}
                  onChange={this.changeField}
                  small={true}
                />
              </div>
              <div className="col col-lg-3" style={{textAlign: 'start'}}>
                <div className="form-group">
                  <b><label>Calculated Cost</label></b>
                  <div><b>{currencyToDollars(this.props.cost)}</b></div>
                </div>
              </div>
            </div>
        );
      } else if (key === 'body-work') {
        components.push(
          <TextArea
            disabled={this.props.disabled}
                field={objFields[key]}
                onChange={this.changeField}
                style={objFields[key].style}
                extraClass={'textarea-notes'}
              />
            );
          } else {
            components.push(
              <Input
                disabled={this.props.disabled}
                field={objFields[key]}
                onChange={this.changeField}
              />
            );
          }
            }

            if (components) {
            return components;
          }

            return null;
            }

            getMaterialsCost() {
            const cost = this.props.getMaterialsCost();
            this.changeField('material', {value: cost.toString(), name: 'material'});
          }

            changeField(name, field) {
            this.props.onChange(name, field);
          }

            render() {
            return (
            <div className="card rounded mb-3">
            <div className="card-header rounded-top">
            Financial Info
            </div>
            <div className="card-block">
            <div className="row">
            <div className="col col-lg-12">
          {this.buildFields()}
          </div>
      </div>
      </div>
      </div>
      )
        ;
      }
      }

      FinInfo.propTypes = {
        fields: PropTypes.object,
          onChange
      :
        PropTypes.func,
          disabled
      :
        PropTypes.bool,
      };



// WEBPACK FOOTER //
// ./src/common/FinInfo/index.js